import { ComponentChildren } from 'preact';
import { CloseButton } from './close-button/close-button';
import './sidebar.css';

interface SidebarProps {
  children: ComponentChildren;
  visible: boolean;
  onClose: () => void;
}

export const Sidebar = ({ children, visible, onClose }: SidebarProps) => {
  return (
    <>
      <CloseButton onClick={onClose} visible={visible} />
      <aside className={`sidebar ${visible ? 'visible' : 'hidden'}`}>
        {children}
      </aside>
      <div className={`sidebar-spacer ${visible ? 'visible' : 'hidden'}`} />
    </>
  );
};
